export const invertedMessages = {
  'Consulted items that must be completed': 'REVIEW_CONSULTED_ITEMS',
  'To-Do items that you must complete': 'REVIEW_TODO_ITEMS',
  'Step 1 of 2': 'REVIEW_SUBMIT_STEP1',
  'Step 2 of 2': 'REVIEW_SUBMIT_STEP2',
  'You still have {reviewinfo} before your certification can be submitted.':
    'REVIEW_TODO_DESCRIPTION',
  "Review the items you've certified, and send them to the primary certifier {name} who'll complete and submit the certification.":
    'REVIEW_CERTIFIED_DETAILS',
  'Locked by User': 'CERTIFICATION_LOCKED',
  'Your certification {certificationName} has been submitted.':
    'REVIEW_CERTIFICTAION_NAME',
  'Certification succesfully submitted': 'REVIEW_CERTIFICATION_SUBMITTED',
  'Review and Submit Your Certification': 'REVIEW_AND_SUBMIT_CERTIFICATION',
  'Your Certification Is Incomplete': 'REVIEW_YOUR_CERTIFICATION_INCOMPLETE',
  'Complete Your Certification': 'REVIEW_COMPLETE_CERTIFICATION',
};
